import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const OfferGalleryEmpty: React.FC = () => {
  return (
    <div className={styles['image']}>
      <IconPlaceholderImages24 width={40} height={40} color="surface-neutral-pressed" display="block" />
    </div>
  );
};
